import React, { useState, useEffect } from 'react';
import Hero from './Hero';
import StatsStrip from './StatsStrip';
import AboutNcet from './AboutNcet';
import WhyNcet from './WhyNcet';
import Anniversary from './Anniversary';
import Accreditations from './Accreditations';
import ToriiMinds from './ToriiMinds';
import StudyFeature from './StudyFeature';
import BuildingCareers from './BuildingCareers';
import Recruiters from './Recruiters';
import CampusLifeSection from './CampusLifeSection';
import LatestNotifications from './LatestNotifications';
import CtaBand from './CtaBand';
import Reveal from './Reveal';
import { getHome } from '../../services/data.service';

const HomeMain = () => {
	// Dynamic content from the backend; each section falls back to its bundled
	// JSON (src/data/home/*) until this resolves, so there is no regression.
	const [content, setContent] = useState(null);
	useEffect(() => {
		let active = true;
		(async () => {
			try {
				const res = await getHome();
				const homeData = res?.data?.data || res?.data || res;
				if (active && homeData && typeof homeData === 'object') {
					setContent(homeData.data || homeData);
				}
			} catch (e) {
				/* keep bundled fallbacks */
			}
		})();
		return () => { active = false; };
	}, []);
	const c = content || {};

	return (
		<>
			<div className="react-wrapper">
				<div className="react-wrapper-inner">
					<Hero data={c.hero} />
					<Reveal><StatsStrip data={c.stats} /></Reveal>
					<Reveal><AboutNcet data={c.about} /></Reveal>
					<Reveal><Anniversary data={c.anniversary} knownFor={c.knownFor} /></Reveal>
					<ToriiMinds data={c.toriiMinds} />
					{/* "Why NCET" section commented out per request */}
					{/* <Reveal><WhyNcet data={c.whyNcet} /></Reveal> */}
					<Reveal><Accreditations data={c.accreditations} /></Reveal>
					<Reveal><StudyFeature data={c.study} /></Reveal>
					<Reveal><BuildingCareers data={c.careers} featured={c.featuredPlacements} /></Reveal>
					<Reveal><Recruiters data={c.companies} /></Reveal>
					<Reveal><CampusLifeSection data={c.campusLife} /></Reveal>
					<Reveal><LatestNotifications data={c.notifications} /></Reveal>
					<Reveal><CtaBand data={c.cta} /></Reveal>
				</div>
			</div>
		</>
	);
};

export default HomeMain;
